<template>
  <v-container>
    <div>
      <v-checkbox v-model="v2" label="v2"></v-checkbox>
    </div>
    <div class="mt-3" v-if="v2">
      <iframe
        :src="urlV2"
        frameborder="0"
        type="application/pdf"
        width="100%"
        height="800px"
      ></iframe>
    </div>
    <div class="mt-3" v-else>
      <iframe
        :src="url"
        frameborder="0"
        type="application/pdf"
        width="100%"
        height="800px"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import "jspdf-autotable";
import { jsPDF } from "jspdf";
import moment from "moment";
import { mapState } from "vuex";
import base64 from "../../../services/base64";

export default {
  name: "print-invoice-preview",
  computed: {
    ...mapState("external", ["contacts"]),
    ...mapState("auth", ["userDetail"]),
    total() {
      let total = 0;
      this.saleDownPayment.products.forEach(x => {
        total += x.total;
      });
      return total;
    },
  },
  data() {
    return {
      saleDownPayment: {},
      url: "",
      urlV2: "",
      v2: false,
    };
  },
  methods: {
    async preview() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("saleInvoice/getPreview", this.$route.query)
        .then(async response => {
          this.saleDownPayment = response.data;
          await this.$store.dispatch("external/getContact", response.data.customerId);
          this.createPdf();
          this.createPdfV2();
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    contactName(id) {
      const contact = this.contacts.find(x => x.id === id);
      const name = contact ? contact.name : "";
      return name;
    },
    calculateDiscount(unitPrice) {
      if (this.saleDownPayment.discount > 0 && this.saleDownPayment.discount <= 100) {
        return unitPrice - unitPrice * (this.saleDownPayment.discount / 100);
      }
      return unitPrice;
    },
    setNewArray(items) {
      const array = [];
      items.forEach((x, index) => {
        if (items.length - 1 == index) {
          array.push([
            {
              content: index + 1,
              styles: { valign: "top", halign: "left" },
            },
            {
              content: x.partNumber,
              styles: { valign: "top", halign: "left" },
            },
            {
              content: this.formatText(x.mfr),
              styles: { valign: "top", halign: "left" },
            },
            {
              content:
                x.partDesc +
                " " +
                this.formatRemark(x.remark) +
                "\n\n\n\n\n" +
                this.formatBank(x.bank),
              styles: { valign: "top", halign: "left" },
            },
            {
              content: x.quantity + " " + this.formatText(x.unitMeasure),
              styles: { valign: "top", halign: "left" },
            },
            {
              content: this.formatPrice(this.calculateDiscount(x.unitPrice)),
              styles: { valign: "top", halign: "right" },
            },
            {
              content: this.formatPrice(this.calculateDiscount(x.unitPrice) * x.quantity),
              styles: { valign: "top", halign: "right" },
            },
          ]);
        } else {
          array.push([
            {
              content: index + 1,
              styles: { valign: "top", halign: "left" },
            },
            {
              content: x.partNumber,
              styles: { valign: "top", halign: "left" },
            },
            {
              content: this.formatText(x.mfr),
              styles: { valign: "top", halign: "left" },
            },
            {
              content: x.partDesc + " " + this.formatRemark(x.remark),
              styles: { valign: "top", halign: "left" },
            },
            {
              content: x.quantity + " " + this.formatText(x.unitMeasure),
              styles: { valign: "top", halign: "left" },
            },
            {
              content: this.formatPrice(this.calculateDiscount(x.unitPrice)),
              styles: { valign: "top", halign: "right" },
            },
            {
              content: this.formatPrice(this.calculateDiscount(x.unitPrice) * x.quantity),
              styles: { valign: "top", halign: "right" },
            },
          ]);
        }
      });
      return array;
    },
    formatBank(bank) {
      if (bank) {
        let first = `ACCOUNT BANK :\n${bank.bankName}\nCABANG ${bank.branch},\n${bank.address}\nA/N : ${bank.ownerName}\n`;
        bank.items.forEach(x => {
          first = first + `NO : ${x.accountNumber}\n`;
        });
        let result =
          first + `SWIFT CODE : ${bank.swiftCode}\nPlease pay the full amount of this invoice`;
        return result;
      }
      return "";
    },
    formatRemark(remark) {
      if (remark) {
        return remark;
      }
      return "";
    },
    formatText(text) {
      return text.charAt(0) + text.slice(1).toLowerCase();
    },
    checkPph() {
      if (this.saleDownPayment.pphAmount > 0) {
        return [
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: "Tot.Ex.PPn :",
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.totalAmount),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: `Total ${this.saleDownPayment.percentageInvoice}%`,
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.totalAmountAfterInvoice),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: "DPP Nilai Lain",
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(
                Math.ceil((this.saleDownPayment.totalAmountAfterInvoice * 11) / 12).toFixed(0)
              ),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: `Art 23 Income Tax (WHT)`,
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.pphAmount),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              // content: `PPN ${this.saleDownPayment.percentagePpn}%`,
              content: `PPN`,
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(this.saleDownPayment.taxAmount),
              styles: { valign: "middle", halign: "right" },
            },
          ],
          [
            {
              colSpan: 5,
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0 },
            },
            {
              content: "Total",
              styles: { valign: "middle", halign: "center", fontStyle: "bold" },
            },
            {
              content: this.formatPrice(
                this.saleDownPayment.totalAmountAfterTax - this.saleDownPayment.pphAmount
              ),
              styles: { valign: "middle", halign: "right" },
            },
          ],
        ];
      }
      return [
        [
          {
            colSpan: 5,
            content: "",
            styles: { valign: "middle", halign: "center", lineWidth: 0 },
          },
          {
            content: "Tot.Ex.PPn :",
            styles: { valign: "middle", halign: "center", fontStyle: "bold" },
          },
          {
            content: this.formatPrice(this.total),
            styles: { valign: "middle", halign: "right" },
          },
        ],
        [
          {
            colSpan: 5,
            content: "",
            styles: { valign: "middle", halign: "center", lineWidth: 0 },
          },
          {
            content: `Total ${this.saleDownPayment.percentageInvoice}%`,
            styles: { valign: "middle", halign: "center", fontStyle: "bold" },
          },
          {
            content: this.formatPrice(this.saleDownPayment.totalAmountAfterInvoice),
            styles: { valign: "middle", halign: "right" },
          },
        ],
        [
          {
            colSpan: 5,
            content: "",
            styles: { valign: "middle", halign: "center", lineWidth: 0 },
          },
          {
            content: "DPP Nilai Lain",
            styles: { valign: "middle", halign: "center", fontStyle: "bold" },
          },
          {
            content: this.formatPrice(
              Math.ceil((this.saleDownPayment.totalAmountAfterInvoice * 11) / 12).toFixed(0)
            ),
            styles: { valign: "middle", halign: "right" },
          },
        ],
        [
          {
            colSpan: 5,
            content: "",
            styles: { valign: "middle", halign: "center", lineWidth: 0 },
          },
          {
            // content: `PPN ${this.saleDownPayment.percentagePpn}%`,
            content: `PPN`,
            styles: { valign: "middle", halign: "center", fontStyle: "bold" },
          },
          {
            content: this.formatPrice(this.saleDownPayment.taxAmount),
            styles: { valign: "middle", halign: "right" },
          },
        ],
        [
          {
            colSpan: 5,
            content: "",
            styles: { valign: "middle", halign: "center", lineWidth: 0 },
          },
          {
            content: "Total",
            styles: { valign: "middle", halign: "center", fontStyle: "bold" },
          },
          {
            content: this.formatPrice(this.saleDownPayment.totalAmountAfterTax),
            styles: { valign: "middle", halign: "right" },
          },
        ],
      ];
    },
    createPdf() {
      const doc = new jsPDF();
      let totalPagesExp = "{total_pages_count_string}";

      doc.autoTable({
        margin: { top: 110, left: 10 },
        theme: "plain",
        head: [["No", "Part#", "Mfr", "Description", "Qty", "Unit Price", "Line Total"]],
        body: [...this.setNewArray(this.saleDownPayment.products), ...this.checkPph()],
        styles: {
          valign: "middle",
          lineWidth: 0.1,
          halign: "left",
          lineColor: "black",
          fontSize: 8,
        },
        headStyles: {
          valign: "middle",
          halign: "center", //'center' or 'right',
          fillColor: "#DDDDDD",
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 25 },
          2: { cellWidth: 20 },
          3: { cellWidth: 60 },
          4: { cellWidth: 12 },
          5: { cellWidth: 30 },
          6: { cellWidth: 30 },
          // etc
        },
        didParseCell: function(data) {
          if (data.section === "body" && data.column.index === 5 && data.row.raw.length === 3) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = "#DDDDDD";
          }
        },
        didDrawPage: () => {
          const item = this.saleDownPayment;
          let str = doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }

          doc.addImage(base64.logoUrl, "JPEG", 10, 10, 90, 25);

          doc.setFont("Times");
          doc.setFontSize(10);
          doc.text("INTERCON PLAZA BLOK D. 11", 10, 40);
          doc.text("JL. MERUYA ILIR, SRENGSENG-KEMBANGAN", 10, 45);
          doc.text("Phone   (62-21)7587-9949/51", 10, 50);
          doc.text("Fax     (62-21)7587-9952", 10, 55);

          doc.setFont("Times", "bold");
          doc.setFontSize(15);
          doc.text("INVOICE", 140, 15);
          doc.setFont("Times", "normal");
          doc.setFontSize(10);

          const poMaxLength = 40;

          let poNumber = item.purchaseOrderNumber;

          if (poNumber && poNumber.length > poMaxLength) {
            poNumber = poNumber.substring(0, poMaxLength);
          }

          let body = [
            ["Invoice No.", item.invoiceNumber],
            ["Invoice Date", `${moment(item.invoiceDate).format("DD-MMMM-yyyy")}`],
            ["Cust. PO No.", poNumber],
            ["Term", `${item.invoiceDuration} DAYS`],
            ["Due Date", `${moment(item.invoiceDueDate).format("DD-MMMM-yyyy")}`],
            ["Page No.", str],
          ];
          if (item.type === "DO") {
            let listDo = item.listDo.split(",");
            if (listDo.length > 2) {
              body.splice(2, 0, ["Cust. DO No.", listDo.slice(0, 2).join(",")]);
            } else {
              body.splice(2, 0, ["Cust. DO No.", item.listDo]);
            }
          }

          doc.autoTable({
            startY: 20,
            theme: "plain",
            tableWidth: 90,
            margin: { left: 105 },
            body: body,
            styles: {
              valign: "middle",
              tableWidth: "auto",
              lineWidth: 0.1,
              halign: "left",
              lineColor: "black",
              fontSize: 8,
              cellPadding: 1,
            },
            didParseCell: function(data) {
              if (data.section === "body" && data.column.index === 0) {
                data.cell.styles.fontStyle = "bold";
                data.cell.styles.fillColor = "#DDDDDD";
              }
            },
          });

          const tableY = doc.lastAutoTable.finalY + 3;
          doc.rect(10, tableY + 5, 90, 40);
          doc.rect(105, tableY + 5, 90, 40);

          doc.setFont("Times", "bold");
          doc.setFontSize(11);
          doc.text("CUSTOMER NAME", 12, tableY + 10);
          doc.setFontSize(10);
          doc.text(item.customerName, 12, tableY + 15);

          doc.setFont("Times", "normal");
          doc.setFontSize(10);
          let splitTitle = doc.splitTextToSize(item.customerAddress, 85);
          let size = doc.getTextDimensions(splitTitle[splitTitle.length - 1]);
          doc.text(splitTitle, 12, tableY + 20);
          doc.text(
            `Phone    ${item.phone == null ? "" : item.phone}`,
            12,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.text(
            `fax      ${item.fax == null ? "" : item.fax}`,
            62,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.setFont("Times", "bold");
          doc.setFontSize(10);
          doc.text(
            `Contact Name      ${this.contactName(item.billToContact)}`,
            12,
            tableY + 35 + Math.ceil(size.h)
          );

          doc.setFont("Times", "bold");
          doc.setFontSize(11);
          doc.text("BILL TO", 107, tableY + 10);
          doc.setFontSize(10);
          doc.text(item.customerName, 107, tableY + 15);

          doc.setFont("Times", "normal");
          doc.setFontSize(10);
          doc.text(splitTitle, 107, tableY + 20);
          doc.text(
            `Phone    ${item.phone == null ? "" : item.phone}`,
            107,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.text(
            `fax      ${item.fax == null ? "" : item.fax}`,
            157,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.setFont("Times", "bold");
          doc.setFontSize(10);
          doc.text(
            `Contact Name      ${this.contactName(item.billToContact)}`,
            107,
            tableY + 35 + Math.ceil(size.h)
          );

          // let pageSize = doc.internal.pageSize;
          // let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        },
      });

      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }

      const y = doc.lastAutoTable.finalY;
      if (y > 240) {
        doc.addPage();
        let str = doc.internal.getNumberOfPages();
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          str = str + " of " + str;
        }
        doc.addImage(base64.logoUrl, "JPEG", 10, 10, 90, 25);

        doc.setFont("Times");
        doc.setFontSize(10);
        doc.text("INTERCON PLAZA BLOK D. 11", 10, 40);
        doc.text("JL. MERUYA ILIR, SRENGSENG-KEMBANGAN", 10, 45);
        doc.text("Phone   (62-21)7587-9949/51", 10, 50);
        doc.text("Fax     (62-21)7587-9952", 10, 55);

        doc.setFont("Times", "bold");
        doc.setFontSize(15);
        doc.text("INVOICE", 140, 15);
        doc.setFont("Times", "normal");
        doc.setFontSize(10);
        let body = [
          ["Invoice No.", this.saleDownPayment.invoiceNumber],
          ["Invoice Date", `${moment(this.saleDownPayment.invoiceDate).format("DD-MMMM-yyyy")}`],
          ["Cust. PO No.", this.saleDownPayment.purchaseOrderNumber],
          ["Term", `${this.saleDownPayment.invoiceDuration} DAYS`],
          ["Due Date", `${moment(this.saleDownPayment.invoiceDueDate).format("DD-MMMM-yyyy")}`],
          ["Page No.", str],
        ];
        if (this.saleDownPayment.type === "DO") {
          body.splice(2, 0, [
            "Cust. DO No.",
            this.saleDownPayment.listDo
              .split(",")
              .slice(0, 2)
              .join(","),
          ]);
        }
        doc.autoTable({
          startY: 20,
          theme: "plain",
          tableWidth: 90,
          margin: { left: 105 },
          body: body,
          styles: {
            valign: "middle",
            tableWidth: "auto",
            lineWidth: 0.1,
            halign: "left",
            lineColor: "black",
            fontSize: 8,
            cellPadding: 1,
          },
          didParseCell: function(data) {
            if (data.section === "body" && data.column.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = "#DDDDDD";
            }
          },
        });
        const tableY = doc.lastAutoTable.finalY + 3;
        doc.rect(10, tableY + 5, 90, 48);
        doc.rect(105, tableY + 5, 90, 48);

        doc.setFont("Times", "bold");
        doc.setFontSize(11);
        doc.text("CUSTOMER NAME", 12, tableY + 10);
        doc.setFontSize(10);
        doc.text(this.saleDownPayment.customerName, 12, tableY + 15);

        doc.setFont("Times", "normal");
        doc.setFontSize(10);
        let splitTitle = doc.splitTextToSize(this.saleDownPayment.customerAddress, 80);
        let size = doc.getTextDimensions(splitTitle[splitTitle.length - 1]);
        doc.text(splitTitle, 12, tableY + 20);
        doc.text(
          `Phone     ${this.saleDownPayment.phone == null ? "" : this.saleDownPayment.phone}`,
          12,
          tableY + 36 + Math.ceil(size.h)
        );
        doc.text(
          `fax      ${this.saleDownPayment.fax == null ? "" : this.saleDownPayment.fax}`,
          62,
          tableY + 36 + Math.ceil(size.h)
        );
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text(
          `Contact Name      ${this.contactName(this.saleDownPayment.billToContact)}`,
          12,
          tableY + 43 + Math.ceil(size.h)
        );

        doc.setFont("Times", "bold");
        doc.setFontSize(11);
        doc.text("BILL TO", 107, tableY + 10);
        doc.setFontSize(10);
        doc.text(this.saleDownPayment.customerName, 107, tableY + 15);

        doc.setFont("Times", "normal");
        doc.setFontSize(10);
        doc.text(splitTitle, 107, tableY + 20);
        doc.text(
          `Phone    ${this.saleDownPayment.phone == null ? "" : this.saleDownPayment.phone}`,
          107,
          tableY + 36 + Math.ceil(size.h)
        );
        doc.text(
          `fax      ${this.saleDownPayment.fax == null ? "" : this.saleDownPayment.fax}`,
          157,
          tableY + 36 + Math.ceil(size.h)
        );
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text(
          `Contact Name      ${this.contactName(this.saleDownPayment.billToContact)}`,
          107,
          tableY + 43 + Math.ceil(size.h)
        );
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text("PREPARED BY :", 30, 247);
        doc.setFontSize(8);
        doc.text(this.userDetail.name, 30, 282);

        doc.setFont("Times", "normal");
        doc.setFontSize(9);
        doc.text("Note :", 140, 264);
        doc.text(
          "Please quote our invoice numbers when making payment. if multiple invoices are included in one payment, please let all invoices being paid",
          140,
          274,
          { maxWidth: 60 }
        );
      } else {
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text("PREPARED BY :", 30, 247);
        doc.setFontSize(8);
        doc.text(this.userDetail.name, 30, 282);

        doc.setFont("Times", "normal");
        doc.setFontSize(9);
        doc.text("Note :", 140, 264);
        doc.text(
          "Please quote our invoice numbers when making payment. if multiple invoices are included in one payment, please let all invoices being paid",
          140,
          274,
          { maxWidth: 60 }
        );
      }

      this.url = doc.output("datauristring");
    },
    createPdfV2() {
      const doc = new jsPDF();
      let totalPagesExp = "{total_pages_count_string}";

      const columns = ["No", "Part#", "Mfr", "Description", "Qty", "Unit Price", "Line Total"];
      const bodyDataItems = [...this.setNewArray(this.saleDownPayment.products)];
      const bodyDataTotal = [bodyDataItems[bodyDataItems.length - 1], ...this.checkPph()];

      doc.autoTable({
        margin: { top: 105, left: 10 },
        theme: "plain",
        head: [columns],
        body: bodyDataItems.slice(0, -1),
        styles: {
          valign: "middle",
          lineWidth: 0.1,
          halign: "left",
          lineColor: "black",
          fontSize: 8,
        },
        headStyles: {
          valign: "middle",
          halign: "center", //'center' or 'right',
          fillColor: "#DDDDDD",
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 25 },
          2: { cellWidth: 20 },
          3: { cellWidth: 60 },
          4: { cellWidth: 12 },
          5: { cellWidth: 30 },
          6: { cellWidth: 30 },
          // etc
        },
        didDrawPage: () => {
          const item = this.saleDownPayment;
          let str = doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }

          doc.addImage(base64.logoUrl, "JPEG", 10, 10, 90, 25);

          doc.setFont("Times");
          doc.setFontSize(10);
          doc.text("INTERCON PLAZA BLOK D. 11", 10, 40);
          doc.text("JL. MERUYA ILIR, SRENGSENG-KEMBANGAN", 10, 45);
          doc.text("Phone   (62-21)7587-9949/51", 10, 50);
          doc.text("Fax     (62-21)7587-9952", 10, 55);

          doc.setFont("Times", "bold");
          doc.setFontSize(15);
          doc.text("INVOICE", 140, 15);
          doc.setFont("Times", "normal");
          doc.setFontSize(10);

          let body = [
            ["Invoice No.", item.invoiceNumber],
            ["Invoice Date", `${moment(item.invoiceDate).format("DD-MMMM-yyyy")}`],
            ["Cust. PO No.", item.purchaseOrderNumber],
            ["Term", `${item.invoiceDuration} DAYS`],
            ["Due Date", `${moment(item.invoiceDueDate).format("DD-MMMM-yyyy")}`],
            ["Page No.", str],
          ];
          if (item.type === "DO") {
            let listDo = item.listDo.split(",");
            if (listDo.length > 2) {
              body.splice(2, 0, ["Cust. DO No.", listDo.slice(0, 2).join(",")]);
            } else {
              body.splice(2, 0, ["Cust. DO No.", item.listDo]);
            }
          }

          doc.autoTable({
            startY: 20,
            theme: "plain",
            tableWidth: 90,
            margin: { left: 105 },
            body: body,
            styles: {
              valign: "middle",
              tableWidth: "auto",
              lineWidth: 0.1,
              halign: "left",
              lineColor: "black",
              fontSize: 8,
              cellPadding: 1,
            },
            didParseCell: function(data) {
              if (data.section === "body" && data.column.index === 0) {
                data.cell.styles.fontStyle = "bold";
                data.cell.styles.fillColor = "#DDDDDD";
              }
            },
          });

          const tableY = doc.lastAutoTable.finalY + 3;
          doc.rect(10, tableY + 5, 90, 35);
          doc.rect(105, tableY + 5, 90, 35);

          doc.setFont("Times", "bold");
          doc.setFontSize(11);
          doc.text("CUSTOMER NAME", 12, tableY + 10);
          doc.setFontSize(10);
          doc.text(item.customerName, 12, tableY + 15);

          doc.setFont("Times", "normal");
          doc.setFontSize(10);
          let splitTitle = doc.splitTextToSize(item.customerAddress, 85);
          let size = doc.getTextDimensions(splitTitle[splitTitle.length - 1]);
          doc.text(splitTitle, 12, tableY + 20);
          doc.text(
            `Phone    ${item.phone == null ? "" : item.phone}`,
            12,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.text(
            `fax      ${item.fax == null ? "" : item.fax}`,
            62,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.setFont("Times", "bold");
          doc.setFontSize(10);
          doc.text(
            `Contact Name      ${this.contactName(item.billToContact)}`,
            12,
            tableY + 35 + Math.ceil(size.h)
          );

          doc.setFont("Times", "bold");
          doc.setFontSize(11);
          doc.text("BILL TO", 107, tableY + 10);
          doc.setFontSize(10);
          doc.text(item.customerName, 107, tableY + 15);

          doc.setFont("Times", "normal");
          doc.setFontSize(10);
          doc.text(splitTitle, 107, tableY + 20);
          doc.text(
            `Phone    ${item.phone == null ? "" : item.phone}`,
            107,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.text(
            `fax      ${item.fax == null ? "" : item.fax}`,
            157,
            tableY + 31 + Math.ceil(size.h)
          );
          doc.setFont("Times", "bold");
          doc.setFontSize(10);
          doc.text(
            `Contact Name      ${this.contactName(item.billToContact)}`,
            107,
            tableY + 35 + Math.ceil(size.h)
          );

          // let pageSize = doc.internal.pageSize;
          // let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        },
      });

      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }

      const y = doc.lastAutoTable.finalY;
      if (y > 150) {
        doc.addPage();
        doc.autoTable({
          margin: { top: 105, left: 10 },
          theme: "plain",
          head: [columns],
          body: bodyDataTotal, // Only the last row
          styles: {
            valign: "middle",
            lineWidth: 0.1,
            halign: "left",
            lineColor: "black",
            fontSize: 8,
          },
          headStyles: {
            valign: "middle",
            halign: "center",
            fillColor: "#DDDDDD",
          },
          columnStyles: {
            0: { cellWidth: 10 },
            1: { cellWidth: 25 },
            2: { cellWidth: 20 },
            3: { cellWidth: 60 },
            4: { cellWidth: 12 },
            5: { cellWidth: 30 },
            6: { cellWidth: 30 },
          },
          didParseCell: function(data) {
            if (data.section === "body" && data.column.index === 5 && data.row.raw.length === 3) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = "#DDDDDD";
            }
          },
        });

        let str = doc.internal.getNumberOfPages();
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          str = str + " of " + str;
        }
        doc.addImage(base64.logoUrl, "JPEG", 10, 10, 90, 25);

        doc.setFont("Times");
        doc.setFontSize(10);
        doc.text("INTERCON PLAZA BLOK D. 11", 10, 40);
        doc.text("JL. MERUYA ILIR, SRENGSENG-KEMBANGAN", 10, 45);
        doc.text("Phone   (62-21)7587-9949/51", 10, 50);
        doc.text("Fax     (62-21)7587-9952", 10, 55);

        doc.setFont("Times", "bold");
        doc.setFontSize(15);
        doc.text("INVOICE", 140, 15);
        doc.setFont("Times", "normal");
        doc.setFontSize(10);
        let body = [
          ["Invoice No.", this.saleDownPayment.invoiceNumber],
          ["Invoice Date", `${moment(this.saleDownPayment.invoiceDate).format("DD-MMMM-yyyy")}`],
          ["Cust. PO No.", this.saleDownPayment.purchaseOrderNumber],
          ["Term", `${this.saleDownPayment.invoiceDuration} DAYS`],
          ["Due Date", `${moment(this.saleDownPayment.invoiceDueDate).format("DD-MMMM-yyyy")}`],
          ["Page No.", str],
        ];
        if (this.saleDownPayment.type === "DO") {
          body.splice(2, 0, [
            "Cust. DO No.",
            this.saleDownPayment.listDo
              .split(",")
              .slice(0, 2)
              .join(","),
          ]);
        }
        doc.autoTable({
          startY: 20,
          theme: "plain",
          tableWidth: 90,
          margin: { left: 105 },
          body: body,
          styles: {
            valign: "middle",
            tableWidth: "auto",
            lineWidth: 0.1,
            halign: "left",
            lineColor: "black",
            fontSize: 8,
            cellPadding: 1,
          },
          didParseCell: function(data) {
            if (data.section === "body" && data.column.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = "#DDDDDD";
            }
          },
        });
        const tableY = doc.lastAutoTable.finalY + 3;
        doc.rect(10, tableY + 5, 90, 35);
        doc.rect(105, tableY + 5, 90, 35);

        doc.setFont("Times", "bold");
        doc.setFontSize(11);
        doc.text("CUSTOMER NAME", 12, tableY + 10);
        doc.setFontSize(10);
        doc.text(this.saleDownPayment.customerName, 12, tableY + 15);

        doc.setFont("Times", "normal");
        doc.setFontSize(10);
        let splitTitle = doc.splitTextToSize(this.saleDownPayment.customerAddress, 80);
        let size = doc.getTextDimensions(splitTitle[splitTitle.length - 1]);
        doc.text(splitTitle, 12, tableY + 20);
        doc.text(
          `Phone     ${this.saleDownPayment.phone == null ? "" : this.saleDownPayment.phone}`,
          12,
          tableY + 31 + Math.ceil(size.h)
        );
        doc.text(
          `fax      ${this.saleDownPayment.fax == null ? "" : this.saleDownPayment.fax}`,
          62,
          tableY + 31 + Math.ceil(size.h)
        );
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text(
          `Contact Name      ${this.contactName(this.saleDownPayment.billToContact)}`,
          12,
          tableY + 35 + Math.ceil(size.h)
        );

        doc.setFont("Times", "bold");
        doc.setFontSize(11);
        doc.text("BILL TO", 107, tableY + 10);
        doc.setFontSize(10);
        doc.text(this.saleDownPayment.customerName, 107, tableY + 15);

        doc.setFont("Times", "normal");
        doc.setFontSize(10);
        doc.text(splitTitle, 107, tableY + 20);
        doc.text(
          `Phone    ${this.saleDownPayment.phone == null ? "" : this.saleDownPayment.phone}`,
          107,
          tableY + 31 + Math.ceil(size.h)
        );
        doc.text(
          `fax      ${this.saleDownPayment.fax == null ? "" : this.saleDownPayment.fax}`,
          157,
          tableY + 31 + Math.ceil(size.h)
        );
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text(
          `Contact Name      ${this.contactName(this.saleDownPayment.billToContact)}`,
          107,
          tableY + 35 + Math.ceil(size.h)
        );
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text("PREPARED BY :", 30, 247);
        doc.setFontSize(8);
        doc.text(this.userDetail.name, 30, 282);

        doc.setFont("Times", "normal");
        doc.setFontSize(9);
        doc.text("Note :", 140, 264);
        doc.text(
          "Please quote our invoice numbers when making payment. if multiple invoices are included in one payment, please let all invoices being paid",
          140,
          274,
          { maxWidth: 60 }
        );
      } else {
        doc.setFont("Times", "bold");
        doc.setFontSize(10);
        doc.text("PREPARED BY :", 30, 247);
        doc.setFontSize(8);
        doc.text(this.userDetail.name, 30, 282);

        doc.setFont("Times", "normal");
        doc.setFontSize(9);
        doc.text("Note :", 140, 264);
        doc.text(
          "Please quote our invoice numbers when making payment. if multiple invoices are included in one payment, please let all invoices being paid",
          140,
          274,
          { maxWidth: 60 }
        );
      }

      this.urlV2 = doc.output("datauristring");
    },
  },
  created() {
    this.preview();
  },
};
</script>

<style></style>
